import {
  Component,
  effect,
  HostBinding,
  inject,
  input,
  model,
  OnInit,
  signal,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import {languages} from "../../../language-manager/language";
import {NotificationService} from "../../notifications/services/notification.service";
import {Subscription} from "rxjs";
import {simpleHttpCancel} from "../../../utilities/simpleHttpCancel";
import type Language from "../../../language-manager/lang-manager/language.model";
import {AuthService} from "../../../auth/auth.service";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import User from "../../../auth/models/user.modes";
import {CompanyService} from "../../../components/company-picker/company.service";

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrl: './top-bar.component.scss',
    host: { 'class': 'nab-bar' },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopBarComponent implements OnInit {
  private notificationService = inject(NotificationService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private translateService = inject(TranslateService);


  companyService = inject(CompanyService);

  private readonly storageLang = 'storageKey';

  subs = new Subscription();
  languages = languages;

  @HostBinding('class.company-picker') companyPicker = false;
  readonly notificationToggle = output();
  user = input.required<User>();
  lnFlag = signal(null);
  unreadNotifications = signal(null);
  status = signal(1);
  toggleMenu = model(false);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    simpleHttpCancel([this.subs]);
    effect(() => {
      this.companyPicker = !!this.companyService.companies()?.length;
    });
  }

  ngOnInit() {
    this.subs.add(this.notificationService.unread.subscribe(unread => this.unreadNotifications.set(unread > 9 ? '9+' : <any>unread)));

    const currentLang = this.languages.find(e => e.code === this.translateService.currentLang())
    this.lnFlag.set(currentLang.flag);
    this.subs.add(this.translateService.onLangChange.subscribe(lang => {
      this.lnFlag.set(this.languages.find(e => e.code === lang.lang).flag);
    }));
  }

  setLanguage(lang: Language) {
    this.translateService.use(lang.code);
    localStorage.setItem(this.storageLang, JSON.stringify(lang));
    window?.zE("messenger:set", "locale", lang.code === 'en' ? 'en-US' : lang.code);
  }

  logOut() {
    this.authService.logOut().subscribe(() => this.router.navigate(['/auth', 'secret-login']));
  }

  changeState(event: Event, status: number) {
    event.stopPropagation();
    this.status.set(status);
  }

}
